// extracted by mini-css-extract-plugin
export var contentWrapper = "bs-description-module--content-wrapper--Dx3Ii";